export default "__VITE_PUBLIC_ASSET__7b815655__"